(() => {
  function init() {
    document.querySelectorAll('[data-bb-gallery]').forEach(gallery => {
      if (gallery.dataset.bbGalleryReady) return;
      const photos = [...gallery.querySelectorAll(':scope > .bb-preview-image')];
      const buttons = [...gallery.querySelectorAll('[data-bb-photo]')];
      if (!photos.length) return;
      function choose(id) {
        photos.forEach(photo => {photo.classList.toggle('bb-photo-active', photo.dataset.bbMedia === id);photo.hidden=photo.dataset.bbMedia!==id;});
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.bbPhoto === id)));
      }
      buttons.forEach(button => button.addEventListener('click', () => choose(button.dataset.bbPhoto)));
      choose(photos[0].dataset.bbMedia);
      gallery.dataset.bbGalleryReady = 'true';
      if (photos.length < 2) gallery.querySelector('.bb-gallery-choices').hidden = true;
    });
    document.querySelectorAll('.bb-product').forEach(product => {
      const dialog = product.querySelector('.bb-shipping-dialog');
      const opener = product.querySelector('[data-bb-shipping-open]');
      if (dialog && opener && !dialog.dataset.bound) {
        dialog.dataset.bound = 'true';
        opener.addEventListener('click', () => dialog.showModal());
        dialog.querySelector('[data-bb-shipping-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
        dialog.addEventListener('close', () => opener.focus({preventScroll:true}));
      }
      const row = product.querySelector('[data-bb-rating-row]');
      const ratings = [...document.querySelectorAll('#bb-testimonials [data-bb-rating]')].map(el => Number(el.dataset.bbRating)).filter(n => n > 0 && n <= 5);
      if (row) {
        row.hidden = !ratings.length;
        if (ratings.length) {
          const mean = (ratings.reduce((a,b) => a+b,0)/ratings.length).toLocaleString('nl-NL',{maximumFractionDigits:1});
          row.querySelector('a').textContent = `Gemiddeld ${mean}/5 · ${ratings.length} getoonde klantreacties`;
        }
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

